export const env = process.env.REACT_APP_ENVIRONMENT || 'development';
